import { render, staticRenderFns } from "./RuleTableItems.vue?vue&type=template&id=259288fe&scoped=true&"
import script from "./RuleTableItems.vue?vue&type=script&lang=ts&"
export * from "./RuleTableItems.vue?vue&type=script&lang=ts&"
import style0 from "./RuleTableItems.vue?vue&type=style&index=0&id=259288fe&lang=sass&scoped=true&"
import style1 from "./RuleTableItems.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259288fe",
  null
  
)

export default component.exports